module.exports = __webpack_public_path__ + "img/train.623e98fa.jpg";